// LanguageContext.js
// Provides language state and t() translation function to all components.
//
// Usage:
//   const { t, language, setLanguage } = useLanguage();
//   t('nodeInfo') → "Node Info" or "Informacije o čvoru"

import React, { createContext, useContext, useState, useEffect } from 'react';
import translations from './translations';

const LanguageContext = createContext();

const STORAGE_KEY = 'samst_language';

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'en';
    } catch {
      return 'en';
    }
  });

  const setLanguage = (lang) => {
    setLanguageState(lang);
    try { localStorage.setItem(STORAGE_KEY, lang); } catch {}
  };

  // t(key, vars) — translate a key, optionally interpolating {varName} placeholders
  const t = (key, vars = {}) => {
    const str = translations[language]?.[key] ?? translations['en']?.[key] ?? key;
    return Object.entries(vars).reduce(
      (s, [k, v]) => s.replace(`{${k}}`, v),
      str
    );
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
